import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/studentdashboard/StudentSettings.css";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import Swal from "sweetalert2";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";

const StudentSettings = () => {
  const { baseUrl } = useContext(AppContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [student, setStudent] = useState(null);
  const [semester, setSemester] = useState("");

  useEffect(() => {
    getStudentProfile();
  }, []);

  ////////////////////get the email and password from localStorage///////////////

const getStudentProfile = () => {
  const savedStudent = JSON.parse(localStorage.getItem("student"));

  if (savedStudent) {
    setStudent(savedStudent);
    setEmail(savedStudent.email);
    setPassword(savedStudent.password);
    setSemester(savedStudent.semester);
  }
};

  ////////////update password ////////////
  const updatePassword = () => {
    console.log("Button Clicked");
    console.log(newPassword);
    console.log(confirmPassword);

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Passwords do not match!",
      });
      return;
    }

    if (!student) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Student not found. Please login again.",
      });
      return;
    }

    const formData = new FormData();

    formData.append("student_id", student.id);
    formData.append("password", newPassword);

    axios
      .post(`${baseUrl}/student/profile/updatePassword`, formData)
      .then((response) => {
        console.log(response.data);

        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Password Updated Successfully",
          });

          // Update localStorage student object with new password
          const updatedStudent = { ...student, password: newPassword };
          localStorage.setItem("student", JSON.stringify(updatedStudent));
          localStorage.setItem("studentPassword", newPassword);

          setStudent(updatedStudent);
          setPassword(newPassword);

          setNewPassword("");
          setConfirmPassword("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
const updateSemester = () => {
  if (!student) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Student not found. Please login again.",
    });
    return;
  }

  if (!semester) {
    Swal.fire({
      icon: "warning",
      title: "Select Semester",
      text: "Please select a semester.",
    });
    return;
  }

  const formData = new FormData();

  formData.append("student_id", student.id);
  formData.append("semester", semester);

  axios
    .post(`${baseUrl}/student/profile/updateSemester`, formData)
    .then((response) => {
      console.log(response.data);

      if (response.data.success) {
        const updatedStudent = {
          ...student,
          semester: semester,
        };

        localStorage.setItem(
          "student",
          JSON.stringify(updatedStudent)
        );

        setStudent(updatedStudent);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Semester Updated Successfully",
        });
      }
    })
    .catch((error) => {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while updating semester.",
      });
    });
};
  // ✅ Profile Update Alert
  const handleProfileUpdate = () => {
    Swal.fire({
      title: "Success!",
      text: "Profile Updated Successfully 🎉",
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  // ✅ Password Update Alert
  const handlePasswordUpdate = () => {
    Swal.fire({
      title: "Success!",
      text: "Password Changed Successfully 🔐",
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  return (
    <StudentsideLayout>
      <div className="sps-wrapper">
        <h2 className="sps-heading">Settings</h2>

        {/* Profile Settings */}
        <div className="sps-card">
          <h4 className="sps-card-title">Profile Settings</h4>

          <div className="sps-form">
            <div className="sps-field">
              <label>Enter your Email</label>
              <input
                type="email" value={email} readOnly
              />
            </div>

            <div className="sps-field">
              <label>password</label>
              <input
                type="text"
                value={password}
                readOnly
              />

            </div>
            <div className="sps-field">
  <label>Select Semester</label>

  <select
    value={semester}
    onChange={(e) => setSemester(e.target.value)}
  >
    <option value="">Select Semester</option>

    <option value="1">1st Semester</option>
    <option value="2">2nd Semester</option>
    <option value="3">3rd Semester</option>
    <option value="4">4th Semester</option>
    <option value="5">5th Semester</option>
    <option value="6">6th Semester</option>
    <option value="7">7th Semester</option>
    <option value="8">8th Semester</option>
  </select>
</div>
          </div>

        <button
  className="sps-btn"
  onClick={updateSemester}
>
  Save Changes
</button>
        </div>

        {/* Account Settings */}
        <div className="sps-card">
          <h4 className="sps-card-title">Account Settings</h4>

          <div className="sps-form">
            <div className="sps-field">
              <label>Change Password</label>
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>

            <div className="sps-field">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </div>

          <button
            className="sps-btn"
            onClick={updatePassword}
          >
            Update Password
          </button>
        </div>

        {/* Notification Settings */}
        <div className="sps-card">
          <h4 className="sps-card-title">Notification Settings</h4>

          <div className="sps-toggle">
            <span>Email Notifications</span>
            <input type="checkbox" defaultChecked />
          </div>

          <div className="sps-toggle">
            <span>Exam Alerts</span>
            <input type="checkbox" defaultChecked />
          </div>

          <div className="sps-toggle">
            <span>Event Notifications</span>
            <input type="checkbox" />
          </div>
        </div>
      </div>
    </StudentsideLayout>
  );
};

export default StudentSettings;